/**
 *
 * @param {object} parsed_hours = Object of the JSON parsed hours
 */
function formatGoogleHours(parsed_hours) {
    let time_to_day = {};
    let formatted_hours = {};
    let saturday_hours = null,
        sunday_hours = null;
    Object.values(parsed_hours).forEach((day) => {
        const [weekday, time] = day.split(": ");
        if (weekday === "Saturday") saturday_hours = time;
        else if (weekday === "Sunday") sunday_hours = time;
        else {
            time_to_day[time] = time_to_day[time]
                ? [...time_to_day[time], weekday]
                : [weekday];
        }
    });

    Object.entries(time_to_day).forEach(([time, days]) => {
        if (days.length > 1) {
            const first_day_abbr = days[0].substring(0, 3);
            const last_day_abbr = days[days.length - 1].substring(0, 3);
            const final = first_day_abbr + "-" + last_day_abbr;
            formatted_hours[final] = time;
        }
    });

    formatted_hours["Saturdays"] = saturday_hours;
    formatted_hours["Sundays"] = sunday_hours;

    return Object.keys(formatted_hours).length === 0 ? null : formatted_hours;
}

/**
 * Description
 * @param {object} hours_object - Object from Google with service, parts, and sales hours
 * @returns {object} - Object will formatted hours from Google
 */
function getGoogleBusinessHours(hours_object) {
    let {
        service_google_business_hours,
        parts_google_business_hours,
        sales_google_business_hours,
    } = hours_object || null;

    let formatted_google_hours = {};

    formatted_google_hours["service"] = service_google_business_hours
        ? formatGoogleHours(JSON.parse(service_google_business_hours))
        : null;
    formatted_google_hours["parts"] = parts_google_business_hours
        ? formatGoogleHours(JSON.parse(parts_google_business_hours))
        : null;
    formatted_google_hours["sales"] = sales_google_business_hours
        ? formatGoogleHours(JSON.parse(sales_google_business_hours))
        : null;

    return formatted_google_hours;
}

/**
 *
 * @param {object} hours_obj - Object of all the hours for a given category (i.e. service, parts, sales, etc)
 * @returns {object|null} - Returns and object with the formatted hours in it if there are valid hours and null if not
 */
function formatCustomClientHours(hours_obj) {
    let formatted_hours = {};
    const relevantTimeRanges = [
        "Mon-Fri",
        "Mon-Thu",
        "Friday",
        "Saturdays",
        "Sundays",
        "Weekends",
    ];

    const specialTimeRanges = [
        "Holidays",
        "Easter",
        "4th of July",
        "Thanksgiving",
        "Christmas",
        "New Years Day",
    ];

    Object.entries(hours_obj).forEach(([range, hours]) => {
        if (relevantTimeRanges.includes(range) && hours)
            formatted_hours[range] = hours;
        else if (
            hours &&
            !relevantTimeRanges.includes(range) &&
            !specialTimeRanges.includes(range)
        )
            formatted_hours[range] = hours;
        else if (hours && specialTimeRanges.includes(range))
            formatted_hours[range] = hours;
    });

    return Object.keys(formatted_hours).length === 0 ? null : formatted_hours;
}

/**
 *
 * @param {object} custom_client_hours - These are meant to be the hours input by Spark users
 * @return {object} Returns and object that contains the formatted custom hours from Spark
 */
function getCustomClientHours(custom_client_hours) {
    const { service, parts, special } = custom_client_hours;
    const { service_hours, service_hours_saturdays, service_hours_sundays } =
        service;
    const { parts_hours, parts_hours_saturdays, parts_hours_sundays } = parts;
    const all_service_hours = {
            "Mon-Fri": service_hours,
            Saturdays: service_hours_saturdays,
            Sundays: service_hours_sundays,
        },
        all_parts_hours = {
            "Mon-Fri": parts_hours,
            Saturdays: parts_hours_saturdays,
            Sundays: parts_hours_sundays,
        };

    special.forEach((hour_obj) => {
        hour_obj.type === "service"
            ? (all_service_hours[hour_obj.time_range] = hour_obj.hours)
            : (all_parts_hours[hour_obj.time_range] = hour_obj.hours);
    });

    let formatted_hours = {};

    formatted_hours["service"] = formatCustomClientHours(
        all_service_hours,
        "service"
    );
    formatted_hours["parts"] = formatCustomClientHours(
        all_parts_hours,
        "parts"
    );

    return formatted_hours;
}

/**
 *
 * @param {object|null} google_business_hours - Object from the client containing the google business hours. Can be null
 * @param {object|null} custom_hours - Object containing the custom service and parts hours from Spark
 */
function getMapSectionHours(google_business_hours, custom_hours) {
    let formatted_google_hours = null,
        formatted_custom_hours = null,
        map_section_hours = {};

    if (custom_hours)
        formatted_custom_hours = getCustomClientHours(custom_hours);
    if (google_business_hours)
        formatted_google_hours = getGoogleBusinessHours(google_business_hours);

    map_section_hours["service"] =
        formatted_google_hours?.service ??
        formatted_custom_hours?.service ??
        null;

    map_section_hours["parts"] =
        formatted_google_hours?.parts ?? formatted_custom_hours?.parts ?? null;

    map_section_hours["sales"] = formatted_google_hours?.sales ?? null;

    return map_section_hours;
}

export default getMapSectionHours;
